export class Constants {
  // Generic Constants
  public static readonly activeCapability: string = "activeCapability";
  public static readonly cacheSelectedSite: string = "selectedSite";
  public static readonly capability: string = "capability";
  public static readonly capabilityId: string = "capabilityId";
  public static readonly capabilityDomain: string = "capabilityDomain";
  public static readonly capabilityName: string = "capabilityName";
  public static readonly Designcenter: string = "Designcenter";
  public static readonly Teamcenter: string = "Teamcenter";
  public static readonly Polarion: string = "Polarion";
  public static readonly capabilityDetails: string = "capabilityDetails";
  public static readonly defaultCapabilityId: string = "000";
  public static readonly defaultCapabilityName: string = "dummy-capability";
  public static readonly defaultTabComponent: string = "DummyCapability";
  public static readonly defaultToolbarComponent: string = "DummyToolbar";
  public static readonly redirect: string = "redirect";
  public static readonly defaultMobileToolbarComponentRow1: string =
    "DummyMobileToolbarRow1";
  public static readonly defaultMobileToolbarComponentRow2: string =
    "DummyMobileToolbarRow2";
  public static readonly copilotCapabilityId: string =
    "4a156935-b50b-45e3-bf80-d75468ac8dcd";

  //Client Types
  public static readonly androidClientType = "android";
  public static readonly iosClientType = "ios";
  public static readonly teamsPhonesClientType = "teamsPhones";
  public static readonly teamsRoomsAndroidClientType = "teamsRoomsAndroid";
}
